import React, { useEffect, useState, createContext } from "react";

const sessionStorageInitialized =  (sessionStorage.length > 0 && sessionStorage.appState?.length > 0 || 0);
const initState = {
    user: "",
    focus: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.focus || "" : "",
    territory: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.territory || {} : {},
    market: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.market || {} : {},
    currentProduct: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.currentProduct || "" : "",
    prescriber: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.prescriber || {} : {},
    products: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.products || [] : [],
    plans: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.plans || [] : [],
    currentProduct: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.currentProduct || "" : "",
    productDetails: [], 
    category: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.category || "" : "",
    prescriberType: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.prescriberType || "" : "",
    batchPrintCategories: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.batchPrintCategories || [] : [],
    messageCode: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.messageCode || "" : "",
    mainMessage: "",
    role: "",
    roles: sessionStorageInitialized ? JSON.parse(sessionStorage.appState)?.roles || [] : [],
    config: {
        data: {},
        products: [],
        messageTypes: [],
        Dashboard: {}
    },
    configLoaded: false,
    impersonate: {
        isActive: false,
        firstName: "",
        lastName: "",
        email: "",
        role: "",
    },
};

export const AppContext = createContext(initState);

export function AppContextProvider({ children }) {
    const [appState, setAppState] = useState(
        // passing in function = lazy initialization (performance boost)
        () => initState
    );

    useEffect(() => {
        sessionStorage.setItem("appState", JSON.stringify(appState));
    }, [appState]);

    return (
        <AppContext.Provider value={[appState, setAppState]}>
            {children}
        </AppContext.Provider>
    );
}
